import React from 'react';
import { Box } from '@mui/material';
import { getLevelColor, hexToRgba } from './meta';

// Re-export the generic primitives from the words module so verb files
// have a single import root and consumers don't need to know which module
// owns Checkbox/Switch/Dot/IconChip.
export { Checkbox, Switch, Dot, IconChip } from 'components/vocabularyWordsView/primitives';

interface LevelPillProps {
  level?: string | null;
  size?: 'sm' | 'md';
}

/**
 * CEFR-coloured pill (A1/A2/B1/B2/C1/C2) used in the verbs table and on
 * Level-derived chips. Falls back to a neutral grey when the level is unknown.
 */
export const LevelPill: React.FC<LevelPillProps> = ({ level, size = 'md' }) => {
  if (!level) return null;
  const color = getLevelColor(level);
  return (
    <Box
      component={'span'}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: size === 'sm' ? 26 : 30,
        height: size === 'sm' ? 20 : 22,
        px: 0.875,
        borderRadius: 0.75,
        fontSize: size === 'sm' ? 11 : 12,
        fontWeight: 800,
        letterSpacing: '0.02em',
        bgcolor: hexToRgba(color, 0.13),
        color,
      }}
    >
      {level}
    </Box>
  );
};
